export const auth = {
  // Authentication
  welcome: 'مرحباً',
  signInToAccess: 'سجل الدخول للوصول إلى حسابك',
  signInToAccount: 'سجل الدخول إلى حسابك للمتابعة',
  welcomeBack: 'مرحباً بعودتك',
  enterCredentials: 'أدخل بيانات الاعتماد الخاصة بك للوصول إلى حسابك',
  login: 'تسجيل الدخول',
  signup: 'إنشاء حساب',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  fullName: 'الاسم الكامل',
  createAccount: 'إنشاء حساب',
  loginFailed: 'فشل في تسجيل الدخول',
  signupFailed: 'فشل في إنشاء الحساب',
  enterEmail: 'أدخل بريدك الإلكتروني',
  enterPassword: 'أدخل كلمة المرور',
  rememberMe: 'تذكرني',
  keepMeLoggedIn: 'إبقائي متصلاً',
  forgotPassword: 'نسيت كلمة المرور؟',
  signingIn: 'جاري تسجيل الدخول...',
  orContinueWith: 'أو تابع مع',
  continueWithGoogle: 'تابع مع جوجل',
  dontHaveAccount: 'ليس لديك حساب؟',
  alreadyHaveAccount: 'لديك حساب بالفعل؟',
  signInHere: 'سجل الدخول هنا',
  signIn: 'تسجيل الدخول',
  
  // Signup
  joinKiraCar: 'انضم إلى كيرا كار',
  createYourAccount: 'إنشاء حسابك',
  chooseYourPath: 'اختر طريقك وابدأ رحلتك مع أفضل منصة لتأجير السيارات',
  almostThere: 'تقريباً انتهينا! دعنا ننشئ حساب {{role}} الخاص بك',
  customer: 'عميل',
  agency: 'وكالة',
  admin: 'مدير',
  allRoles: 'جميع الأدوار',
  customerRoleTitle: 'أريد استئجار السيارات',
  customerAccount: 'حساب العميل',
  customerRoleDescription: 'تصفح واحجز سيارات رائعة من وكالات موثقة',
  customerDescription: 'تصفح واحجز سيارات رائعة من وكالات موثقة',
  browseThousandsCars: 'تصفح آلاف السيارات',
  instantBooking: 'حجز فوري',
  securePayments: 'مدفوعات آمنة',
  agencyRoleTitle: 'أريد تأجير السيارات',
  agencyAccount: 'حساب الوكالة',
  agencyRoleDescription: 'اعرض أسطولك ونمي عملك في التأجير',
  agencyDescription: 'اعرض أسطولك ونمي عملك في التأجير',
  listUnlimitedCars: 'اعرض سيارات غير محدودة',
  manageBookings: 'إدارة الحجوزات',
  analyticsDashboard: 'لوحة تحكم تحليلية',
  revenueTracking: 'تتبع الإيرادات',
  startRentingToday: 'ابدأ تأجير سيارات رائعة اليوم',
  growYourBusiness: 'نمي عملك في التأجير معنا',
  change: 'تغيير',
  enterFullName: 'أدخل اسمك الكامل',
  enterPhone: 'أدخل رقم هاتفك',
  createPassword: 'إنشاء كلمة مرور قوية',
  confirmPassword: 'تأكيد كلمة المرور',
  confirmYourPassword: 'أكد كلمة المرور',
  creatingAccount: 'جاري إنشاء الحساب...',
  createMyAccount: 'إنشاء حسابي',
  getStarted: 'ابدأ',
  accountCreated: 'تم إنشاء الحساب!',
  accountCreatedSuccess: 'تم إنشاء الحساب بنجاح! يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.',
  checkYourEmailForVerification: 'يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.',
  thankYouForJoining: 'شكراً لانضمامك إلى كيرا كار! لقد أرسلنا بريد تحقق إلى صندوق الوارد الخاص بك. يرجى النقر على الرابط في البريد الإلكتروني لتفعيل حسابك.',
  agencyCreatedSuccess: 'تم إنشاء الوكالة بنجاح! مرحباً بك في كيرا كار.',
  
  // Account Types
  selected: 'محدد',
  selectAccountType: 'اختر نوع الحساب',
  completeRegistration: 'إكمال التسجيل',
  chooseAccountType: 'اختر نوع حسابك للبدء',
  fillYourInformation: 'املأ معلوماتك لإكمال التسجيل',
  backToAccountChoice: 'العودة إلى اختيار الحساب',
  emailSentTo: 'تم إرسال بريد إلكتروني إلى',
  agencySetupAfterVerification: 'يمكنك إعداد وكالتك بعد التحقق من البريد الإلكتروني.',
  continueToSignIn: 'المتابعة إلى تسجيل الدخول',
  
  // Form fields
  phone: 'الهاتف',
  
  // Forgot Password
  forgotPasswordTitle: 'نسيت كلمة المرور؟',
  forgotPasswordSubtitle: 'أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور',
  sendResetLink: 'إرسال رابط الإعادة',
  sendingResetLink: 'جاري الإرسال...',
  rememberPassword: 'تتذكر كلمة المرور؟',
  backToLogin: 'العودة لتسجيل الدخول',
  resetLinkSent: 'تم إرسال رابط الإعادة إلى بريدك الإلكتروني',
  checkEmailForReset: 'يرجى التحقق من بريدك الإلكتروني للحصول على تعليمات إعادة تعيين كلمة المرور',
  checkSpamFolder: 'إذا لم تر البريد الإلكتروني، تحقق من مجلد الرسائل غير المرغوب فيها أو حاول مرة أخرى بعنوان بريد إلكتروني مختلف.',

  // Reset Password
  resetYourPassword: 'إعادة تعيين كلمة المرور',
  enterNewPassword: 'أدخل كلمة المرور الجديدة أدناه',
  newPassword: 'كلمة المرور الجديدة',
  enterNewPasswordPlaceholder: 'أدخل كلمة المرور الجديدة',
  confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
  confirmNewPasswordPlaceholder: 'أكد كلمة المرور الجديدة',
  updatePassword: 'تحديث كلمة المرور',
  updatingPassword: 'جاري تحديث كلمة المرور...',
  passwordResetSuccessfully: 'تم إعادة تعيين كلمة المرور بنجاح',
  passwordUpdatedRedirecting: 'تم تحديث كلمة المرور. جاري التوجيه لتسجيل الدخول...',
  canUseNewPassword: 'يمكنك الآن استخدام كلمة المرور الجديدة لتسجيل الدخول إلى حسابك.',

  // Email Confirmation Page
  emailConfirmationRequired: 'تأكيد البريد الإلكتروني مطلوب',
  emailConfirmationInstructions: 'لإكمال تسجيل وكالتك، يرجى:',
  emailConfirmationStep1: 'التحقق من صندوق الوارد للحصول على رسالة تأكيد',
  emailConfirmationStep2: 'النقر على رابط التأكيد في البريد الإلكتروني',
  emailConfirmationStep3: 'العودة هنا لإكمال إعداد وكالتك',
  emailConfirmationHelp: 'لا ترى البريد الإلكتروني؟ تحقق من مجلد الرسائل غير المرغوب فيها أو حاول التحديث بعد التأكيد.',
  iveConfirmedMyEmail: 'لقد أكدت بريدي الإلكتروني',
  checking: 'جاري التحقق...',

  // Agency Setup Page
  verifyingYourAccount: 'التحقق من حسابك',
  pleaseWaitWhileChecking: 'يرجى الانتظار بينما نتحقق من حالة حسابك...',
  authenticationRequired: 'مطلوب تسجيل الدخول',
  needToBeSignedIn: 'تحتاج إلى تسجيل الدخول لإعداد وكالتك. يرجى تسجيل الدخول بحسابك المؤكد.',
  accessDenied: 'تم رفض الوصول',
  onlyAccessibleToAgency: 'هذه الصفحة متاحة فقط لمستخدمي الوكالة. يرجى التسجيل كوكالة للوصول إلى هذه الميزة.',
  signUpAsAgency: 'التسجيل كوكالة',
  agencyAlreadySetUp: 'تم إعداد الوكالة بالفعل',
  agencyAccountConfigured: 'تم تكوين حساب وكالتك بالفعل. يمكنك الوصول إلى لوحة التحكم مباشرة.',
  goToDashboard: 'الذهاب إلى لوحة التحكم',
  setupRequired: 'الإعداد مطلوب',
  failedToVerifyAccount: 'فشل في التحقق من حالة حسابك.',

  // Agency Registration Form
  pleaseSignInToContinue: 'يرجى تسجيل الدخول للمتابعة مع تسجيل الوكالة.',
  authCheckFailed: 'فشل في التحقق من المصادقة. يرجى المحاولة مرة أخرى.',
  authFailed: 'فشل في المصادقة. قد تحتاج إلى تسجيل الدخول مرة أخرى.',
  pleaseSelectValidImage: 'يرجى تحديد ملف صورة صحيح',
  pleaseFillAllRequired: 'يرجى ملء جميع الحقول المطلوبة',
  failedToCreateAgency: 'فشل في إنشاء الوكالة. يرجى المحاولة مرة أخرى.',
  enterAgencyName: 'أدخل اسم وكالتك',
  briefDescription: 'وصف موجز لشركة تأجير السيارات الخاصة بك...',
  backToSignup: 'العودة إلى التسجيل',
  previous: 'السابق',
  confirmClearProgress: 'هل أنت متأكد من أنك تريد العودة؟ سيتم حفظ تقدمك ويمكنك المتابعة لاحقاً.',
  autoSaved: 'حفظ تلقائي',

  // Agency Registration Form - Step Content
  agencyInformation: 'معلومات الوكالة',
  letsSetupAgencyProfile: 'دعنا ننشئ ملف تعريف وكالة التأجير الخاصة بك',
  stepOfFour: 'الخطوة {{step}} من 4',
  percentComplete: '{{percent}}% مكتمل',
  settingUpSession: 'إعداد جلستك...',
  pleaseWaitPreparing: 'يرجى الانتظار بينما نعد تسجيل وكالتك.',
  
  // Step 1 - Basic Information
  agencyName: 'اسم الوكالة',
  businessEmail: 'البريد الإلكتروني التجاري',
  businessPhone: 'الهاتف التجاري',
  businessDescription: 'وصف الشركة',
  website: 'الموقع الإلكتروني',
  websiteOptional: 'الموقع الإلكتروني (اختياري)',
  
  // Step 2 - Location Information
  streetAddress: 'عنوان الشارع',
  city: 'المدينة',
  country: 'البلد',
  agencyLogo: 'شعار الوكالة',
  agencyLogoOptional: 'شعار الوكالة (اختياري)',
  uploadAgencyLogo: 'قم بتحميل شعار وكالتك (حد أقصى 5 ميجابايت)',
  chooseFile: 'اختر ملف',
  selectCountry: 'اختر البلد',
  
  // Step 3 - Business Settings
  currency: 'العملة',
  taxRate: 'معدل الضريبة (%)',
  operatingHours: 'ساعات العمل',
  openingTime: 'وقت الفتح',
  closingTime: 'وقت الإغلاق',
  openAlways: 'مفتوح 24/7',
  openAlwaysDescription: 'وكالتك مفتوحة بشكل مستمر، 24 ساعة في اليوم و 7 أيام في الأسبوع',
  openAllDay: 'مفتوح 24/7',
  monday: 'الاثنين',
  tuesday: 'الثلاثاء',
  wednesday: 'الأربعاء',
  thursday: 'الخميس',
  friday: 'الجمعة',
  saturday: 'السبت',
  sunday: 'الأحد',
  closed: 'مغلق',
  to: 'إلى',
  
  // Step 4 - Review
  location: 'الموقع',
  businessSettings: 'إعدادات العمل',
  name: 'الاسم',
  description: 'الوصف',
  
  // Navigation
  next: 'التالي',
  createAgency: 'إنشاء الوكالة',
  creatingAgency: 'جاري إنشاء الوكالة...',
  
  // Placeholders
  businessEmailPlaceholder: 'email@company.com',
  businessPhonePlaceholder: '+212 5XX-XX-XX-XX',
  websitePlaceholder: 'https://www.yourwebsite.com',
  streetAddressPlaceholder: '123 شارع الرئيسي',
  cityPlaceholder: 'الرباط',
  cityAutoFilled: 'يتم ملء المدينة تلقائياً عند اختيار العنوان',
  taxRatePlaceholder: '0.0',
  
  // Validation messages
  pleaseFillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
  logoFileSizeTooLarge: 'يجب أن يكون حجم ملف الشعار أقل من 5 ميجابايت',

  // Error messages
  emailNotConfirmed: 'البريد الإلكتروني غير مؤكد. يرجى التحقق من بريدك الإلكتروني والنقر على رابط التحقق.',
  invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.',
  accountNotFound: 'الحساب غير موجود. يرجى التحقق من بريدك الإلكتروني أو التسجيل.',
  passwordTooWeak: 'يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.',
  emailAlreadyExists: 'يوجد حساب بهذا البريد الإلكتروني بالفعل.',
  unexpectedError: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  fillAllFields: 'يرجى ملء جميع الحقول المطلوبة.',
  passwordsDoNotMatch: 'كلمات المرور غير متطابقة.',
  invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صحيح.',
  passwordTooShort: 'يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل',
  invalidExpiredLink: 'رابط غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.',
  unexpectedErrorTryAgain: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  checkingResetLink: 'جاري التحقق من رابط الإعادة...',
  processingRecoveryLink: 'جاري معالجة رابط الاسترداد، يرجى الانتظار...',
  
  // Login specific messages
  loginSuccess: 'تم تسجيل الدخول بنجاح! جاري التوجيه...',
  loginError: 'فشل تسجيل الدخول. يرجى التحقق من بياناتك والمحاولة مرة أخرى.',
  loginTimeout: 'انتهت مهلة تسجيل الدخول. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.',
  slowConnection: 'الاتصال بطيء، يرجى الانتظار...',
  initializing: 'جاري تهيئة التطبيق...',
  retry: 'إعادة المحاولة',
  proceedAnyway: 'المتابعة على أي حال',
  orSignUp: 'أو سجل',
  
  // Account linking messages
  accountExistsSignIn: 'يوجد حساب بهذا البريد الإلكتروني بالفعل. يرجى تسجيل الدخول بدلاً من ذلك.',
  googleAccountSignIn: 'هذا البريد الإلكتروني مرتبط بحساب Google. يرجى تسجيل الدخول باستخدام Google أو إنشاء كلمة مرور لهذا الحساب.',
  accountLinkingFailed: 'فشل في ربط الحساب. يرجى المحاولة تسجيل الدخول باستخدام Google أو الاتصال بالدعم.',
  
  // Dashboard
  signOut: 'تسجيل الخروج',
  
  // Email verification check
  iveVerifiedMyEmail: 'لقد تحققت من بريدي الإلكتروني',
  emailNotYetVerified: 'لم يتم التحقق من البريد الإلكتروني بعد. يرجى النقر على الرابط في بريدك الإلكتروني قبل المتابعة.',
  emailVerifiedSuccessfully: 'تم التحقق من البريد الإلكتروني بنجاح! اكمل إعداد وكالتك الآن.',
  errorDuringVerification: 'خطأ أثناء التحقق. يرجى المحاولة مرة أخرى.',
  agencyConfigurationTitle: 'إعداد الوكالة',
  agencyConfigurationMessage: 'يجب عليك أولاً التحقق من بريدك الإلكتروني عن طريق النقر على الرابط المرسل. بعد التحقق، استخدم الزر أدناه للوصول إلى إعداد وكالتك.',
  accountCreatedSuccessTitle: 'تم إنشاء الحساب بنجاح!',
  checkEmailToActivate: 'تحقق من بريدك الإلكتروني لتفعيل حسابك',
  verificationEmailSent: 'تم إرسال بريد التحقق الإلكتروني',
  verificationEmailSentTo: 'لقد أرسلنا بريد تحقق إلكتروني إلى:',
  nextSteps: 'الخطوات التالية:',
  openEmailInbox: 'افتح صندوق بريدك الإلكتروني',
  lookForKiraCarEmail: 'ابحث عن بريد KiraCar الإلكتروني',
  clickVerificationLink: 'اضغط على رابط التحقق',
  accountWillBeActivated: 'سيتم تفعيل حسابك تلقائياً',
  dontSeeEmail: 'لا ترى البريد الإلكتروني؟ تحقق من مجلد الرسائل غير المرغوب فيها.',
  createAnotherAccount: 'إنشاء حساب آخر',
  
  // Email verification page
  emailVerificationRequired: 'مطلوب التحقق من البريد الإلكتروني',
  pleaseVerifyYourEmail: 'يرجى التحقق من بريدك الإلكتروني لتسجيل الدخول',
  checkYourEmailToVerify: 'تحقق من بريدك الإلكتروني لتأكيد حسابك',
  verifyEmailToLogin: 'تحقق من بريدك الإلكتروني لمتابعة تسجيل الدخول',
  verifyEmailBeforeLogin: 'يرجى التحقق من عنوان بريدك الإلكتروني قبل أن تتمكن من تسجيل الدخول إلى حسابك.',
  clickLinkInEmail: 'انقر على رابط التحقق في بريدك الإلكتروني',
  checkSpamIfNotFound: 'لا تراه؟ تحقق من مجلد الرسائل المزعجة',
  returnHereToCheckVerification: 'عُد هنا للتحقق من التحقق',
  resendVerificationEmail: 'إعادة إرسال بريد التحقق الإلكتروني',
  resending: 'جاري الإرسال...',
  resendIn: 'إعادة الإرسال خلال {{seconds}} ثانية',
  verificationEmailResent: 'تم إعادة إرسال بريد التحقق! تحقق من صندوق الوارد.',
  
  // Email confirmed page
  emailConfirmedSuccessfully: 'تم تأكيد البريد الإلكتروني بنجاح!',
  accountActivatedSuccessfully: 'تم تفعيل حسابك بنجاح',
  readyToSetupAgency: 'أنت الآن جاهز لإعداد وكالتك',
  welcomeToKiraCarPlatform: 'مرحباً بك في منصة كيراكار',
  nextStepAgencySetup: 'الخطوة التالية: إعداد الوكالة',
  nextStepExplore: 'الخطوة التالية: استكشاف كيراكار',
  setupAgencyDetails: 'قم بإعداد تفاصيل وكالتك وابدأ في إدارة مركباتك',
  discoverOurVehicles: 'اكتشف مجموعتنا الواسعة من المركبات المتاحة للإيجار',
  setupMyAgency: 'إعداد وكالتي',
  exploreKiraCar: 'استكشاف كيراكار',
  welcomeToKiraCar: 'مرحباً بك في كيراكار!',
  preparingYourAccount: 'جاري تحضير حسابك...',
  profileNotFound: 'إعداد الحساب غير مكتمل. يرجى الاتصال بالدعم.',
  goToHome: 'الذهاب إلى الصفحة الرئيسية',
  
  // Booking Authentication
  signInToBook: 'تسجيل الدخول للحجز',
  signInToBookDescription: 'يرجى تسجيل الدخول لمتابعة حجز السيارة',
  createAccountToBook: 'إنشاء حساب للحجز',
  createAccountToBookDescription: 'قم بإنشاء حساب لإكمال حجز السيارة',
  signupSuccess: 'تم إنشاء الحساب بنجاح!',
  checkEmailForVerification: 'يرجى التحقق من بريدك الإلكتروني لتأكيد حسابك.',
  backToAccountType: 'العودة إلى نوع الحساب',
  signUp: 'التسجيل',

  // Unauthorized access
  unauthorized: {
    title: 'تم رفض الوصول',
    requiresAccount: 'يتطلب هذا اللوحة حساباً بالدور التالي:',
    currentlyLoggedAs: 'أنت مسجل الدخول حالياً كـ:',
    loginDifferentAccount: 'تسجيل الدخول بحساب آخر',
    signOutAndLogin: 'تسجيل الخروج وتسجيل الدخول',
    loginWithCorrectAccount: 'تسجيل الدخول بالحساب الصحيح',
    backToHome: 'العودة للرئيسية',
    needHelp: 'تحتاج مساعدة؟',
    contactSupport: 'اتصل بالدعم'
  },
  
  // User roles
  roles: {
    admin: 'مدير',
    agency: 'وكالة',
    customer: 'عميل',
    adminDescription: 'وصول كامل وإدارة النظام',
    agencyDescription: 'إدارة المركبات والحجوزات والعملاء',
    customerDescription: 'تصفح وحجز المركبات'
  },
  
  signingOut: 'جاري تسجيل الخروج...',
  backToHome: 'العودة للرئيسية',
  
  // Auth Callback
  signingYouIn: 'جاري تسجيل دخولك...',
  pleaseWaitWhileWeSignYouIn: 'يرجى الانتظار بينما نقوم بتسجيل دخولك وتوجيهك إلى لوحة التحكم',
  
  // Top Bar Links
  imAClient: "أنا عميل",
  imAnAgency: "أنا وكالة"
};